import config from "console_config";
import logger from "Libs/logger";
import { request } from "Libs/platform";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

import { projectCreationActions } from "../projectCreation.reducer";

import type { GithubBranch } from "../projectCreation.types";

const githubAppEndpoint = `${config.URL_API_PROXY}/gh`;

export type FetchGithubBranchesProps = {
  organizationId: string;
  installationId: string;
  repositoryName: string;
};

/**
 * Fetches branches for a selected GitHub repository.
 *
 * This thunk fetches available branches for a specific repository
 * within a GitHub App installation and stores them in Redux state.
 */
export const fetchGithubBranches = createAppAsyncThunk(
  "onboarding/fetchGithubBranches",
  async (
    {
      organizationId,
      installationId,
      repositoryName
    }: FetchGithubBranchesProps,
    { dispatch, rejectWithValue }
  ) => {
    dispatch(
      projectCreationActions.setGitProviderLoading({
        organizationId,
        isLoading: true
      })
    );

    try {
      const branches = (await request(
        `${githubAppEndpoint}/${organizationId}/orgs/${installationId}/repos/${repositoryName}/branches`
      )) as GithubBranch[];

      dispatch(
        projectCreationActions.setGithubBranches({
          organizationId,
          branches
        })
      );

      dispatch(
        projectCreationActions.setGitProviderLoading({
          organizationId,
          isLoading: false
        })
      );

      return { branches };
    } catch (err: unknown) {
      const error = err instanceof Error ? err.message : "An error occurred";

      logger(err, {
        action: "fetchGithubBranches",
        organizationId,
        installationId,
        repositoryName
      });

      dispatch(
        projectCreationActions.setGitProviderError({
          organizationId,
          error
        })
      );

      return rejectWithValue({ error });
    }
  }
);
